import React from 'react';
import { WppTypography, WppSideModal } from '@wppopen/components-library-react';
import { ContentCases } from './ContentCases/ContentCases';
import { Localization, normalizeString } from 'utils';

interface ISideModal {
    isSidebarShown: boolean;
    setIsSidebarShown?: any;
    title: string;
    localization: Localization;
}

export const SideModal = ({
    title,
    isSidebarShown,
    setIsSidebarShown,
    localization,
}: ISideModal) => {
    return (
        <WppSideModal
            key={title}
            open={isSidebarShown}
            size="m"
            onWppSideModalClose={() => setIsSidebarShown(false)}
            onWppSideModalOpen={() => setIsSidebarShown(true)}
            data-testid={`SIDEMODAL.${normalizeString(localization)}.CONTAINER.${normalizeString(
                title,
            )}`}
        >
            <WppTypography
                slot="header"
                data-testid={`SIDEMODAL.${normalizeString(localization)}.TITLE.TEXT`}
                type="2xl-heading"
            >
                {title}
            </WppTypography>
            <div
                slot="body"
                id="txt"
                data-testid={`SIDEMODAL.${normalizeString(localization)}.CONTAINER.CONTENT`}
            >
                {ContentCases[localization][title] || ContentCases[localization]['default']}
            </div>
        </WppSideModal>
    );
};
